import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Branche} from '../../models/Branche';
import {AbcComplettApiService} from '../../services/abc-complett-api/abc-complett-api.service';
import {MatSelectChange} from '@angular/material/select';
import {UntypedFormBuilder} from '@angular/forms';
import {Checkliste} from '../../models/Checkliste';
import {Kontakt} from '../../models/Kontakt';
import {EventEmitterService} from '../../services/event-emitter/event-emitter.service';
import {CookieStorageService} from '../../services/cookie-storage/cookie-storage.service';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints, BreakpointState} from '@angular/cdk/layout';
import {checklisten} from '../../data/checklisten';

@Component({
  selector: 'app-checklisten',
  templateUrl: './checklisten.component.html',
  styleUrls: ['./checklisten.component.scss']
})
export class ChecklistenComponent implements OnInit {

  @ViewChild('checklistImage', {static: true})
  checklistImage: ElementRef;

  private handsetChange: Observable<BreakpointState>;
  private tabletChange: Observable<BreakpointState>;
  private webChange: Observable<BreakpointState>;
  private landscapeChange: Observable<BreakpointState>;
  private portraitChange: Observable<BreakpointState>;
  private isLandscape = false;
  private isHandset = false;

  branchen: Branche[];
  selectedBranche: number;
  name: string;
  email: string;
  telefon: string;
  firma: string;
  adresse: string;
  stadt: string;
  bemerkungen: string;
  kontaktPerMail = true;
  kontaktPerTelefon = true;
  succeded = false;
  error: string;
  nameError: string;
  emailError: string;
  telefonError: string;
  step = 0;
  stepDescriptions = [
    'Wähle Deine Branche',
    'Wie können wir Dich erreichen?',
    'Möchtest Du uns weitere Projektdetails geben?'
  ];

  get cookiesAgreed(): boolean {
    return this.cookieStorage.hasAgreed;
  }

  constructor(
    private apiService: AbcComplettApiService,
    private formBuilder: UntypedFormBuilder,
    private eventEmitterService: EventEmitterService,
    private cookieStorage: CookieStorageService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.eventEmitterService.checklistenBrancheSelectionSet.subscribe(branchenId => {
      this.step = branchenId ? 1 : 0;
      this.selectedBranche = branchenId;
      if (branchenId) {
        this.performBranchenSelection(branchenId);
      }
    });
    this.handsetChange = breakpointObserver.observe([
      Breakpoints.Handset
    ]);
    this.tabletChange = breakpointObserver.observe([
      Breakpoints.Tablet
    ]);
    this.webChange = breakpointObserver.observe([
      Breakpoints.Web
    ]);
    this.landscapeChange = breakpointObserver.observe([
      Breakpoints.HandsetLandscape
    ]);
    this.portraitChange = breakpointObserver.observe([
      Breakpoints.HandsetPortrait
    ]);
  }

  ngOnInit() {
    this.apiService.getBranchen().subscribe(data => {
      this.branchen = data;
    });
    this.portraitChange.subscribe(result => {
      if (result.matches) {
        this.isLandscape = false;
      }
    });
    this.landscapeChange.subscribe(result => {
      if (result.matches) {
        this.isLandscape = true;
      }
    });
    this.handsetChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = true;
      }
    });
    this.tabletChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = false;
      }
    });
    this.webChange.subscribe(result => {
      if (result.matches) {
        this.isHandset = false;
      }
    });
  }

  branchenSelectionChange(event: MatSelectChange) {
    let value = event.value;
    if (!value) {
      value = 'dummy';
    }
    this.performBranchenSelection(value);
    this.step = 1;
  }

  private performBranchenSelection(branchenId: number) {
    this.succeded = false;
    this.checklistImage.nativeElement.src = '../../..' + checklisten[branchenId].imageUrl;
  }

  onContextMenu(event: MouseEvent) {
    event.preventDefault();
    return false;
  }

  sendChecklistenRequest() {
    if (this.cookiesAgreed) {
      const branche = this.selectedBranche;
      const kontakt: Kontakt = {
        firma: this.firma,
        name: this.name,
        adresse: this.adresse,
        stadt: this.stadt,
        email: this.email,
        telefon: this.telefon,
        bemerkungen: this.bemerkungen,
        kontaktPerMail: this.kontaktPerMail,
        kontaktPerTelefon: this.kontaktPerTelefon
      };
      const checkliste: Checkliste = {
        branche,
        kontakt
      };
      this.apiService.sendMailCheckliste(checkliste).subscribe(result => {
        if (result.status === 'success') {
          this.succeded = true;
          this.error = undefined;
        } else {
          this.succeded = false;
          this.error = result.message;
        }
      });
    } else {
      this.eventEmitterService.emitCookiePopup();
    }
  }

  branchenSelectOpened() {
    if (!this.cookiesAgreed) {
      this.eventEmitterService.emitCookiePopup();
    }
  }

  inputFocus(event: any, showHeader: boolean) {
    if (this.isHandset && this.isLandscape) {
      this.eventEmitterService.emitDisplayHeader(showHeader);
      if (!showHeader) {
        event.target.parentElement.scrollIntoView({behavior: 'smooth'});
      }
    }
  }

  resetCheckliste() {
    this.step = 0;
    this.succeded = false;
    this.error = undefined;
    this.selectedBranche = undefined;
    this.checklistImage.nativeElement.src = '../../..' + checklisten.dummy.imageUrl;
  }

  getSelectedBranchenName(): string {
    for (const branche of this.branchen) {
      if (this.selectedBranche === branche.id) {
        return branche.name;
      }
    }
  }

  gotoStep2() {
    if (this.validateStep1()) {
      this.step = 2;
    }
  }

  private validateStep1() {
    if (!this.name || this.name === '') {
      return false;
    }
    if (!this.email || this.email === '') {
      return false;
    }
    if (!this.telefon || this.telefon === '') {
      return false;
    }
    return true;
  }

  getPreviewHeight() {
    let checkliste;
    if (this.selectedBranche) {
      checkliste = checklisten[this.selectedBranche];
    } else {
      checkliste = checklisten.dummy;
    }
    return this.checklistImage.nativeElement.clientHeight / checkliste.pages;
  }

  validateName() {
    if (this.name && this.name !== '') {
      this.nameError = undefined;
    } else {
      this.nameError = 'Gib Deinen Namen ein';
    }
  }

  validateEmail() {
    if (this.email && this.email !== '') {
      this.emailError = undefined;
    } else {
      this.emailError = 'Gib Deine E-Mail Adresse ein';
    }
  }

  validateTelefon() {
    if (this.telefon && this.telefon !== '') {
      this.telefonError = undefined;
    } else {
      this.telefonError = 'Gib Deine Telefonnummer ein';
    }
  }
}
